import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/bars-graphs/radial-bar-chart/radial-bar-chart.js';
      import {Priority} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/types.js';

      export interface Props {
     data?: number[];
     colors?: string[];
     priority?: Priority;
     max?: number;
     circumference?: number;
     legend?: boolean;
     showDebugOverlay?: boolean;
     fixedHeight?: number;
     minRingThickness?: number
   }

      
  
      export type {Priority} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/types.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcRadialBarChart',
  props: {
    data: {},
    colors: {},
    priority: {},
    max: {},
    circumference: {},
    legend: { type: Boolean },
    showDebugOverlay: { type: Boolean },
    fixedHeight: {},
    minRingThickness: {}
  },
  setup(__props: any) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-radial-bar-chart',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})